import React from 'react';
import { useSelector } from 'react-redux';

import { Tooltip, Typography } from 'antd';

import {
    getThemeColorClass,
    getTooltipOverlayClass,
} from '../../../../../utils/helpers/themeHelpers';
import { useOpen } from '../../../../../utils/hooks/useOpen';

import {
    selectDarkMode,
    selectIsSubscriptionExpired,
} from '../../../../../userBrowserSettings/store/browserSettings.selectors';

import EditProfileModal from './EditProfileModal';

const classes = {
    link: 'link-hover-highlight space-no-wrap',
    tooltipOverlay: 'tooltip-overlay',
};

const EditProfileModalWrapper = ({ editableUser }) => {
    const darkMode = useSelector(selectDarkMode);
    const isSubscriptionExpired = useSelector(selectIsSubscriptionExpired);

    const { isOpen, handleOpen } = useOpen();

    return (
        <>
            <Tooltip
                title={
                    isSubscriptionExpired
                        ? "You cannot edit user's profile because your subscription has expired"
                        : ''
                }
                placement='top'
                overlayClassName={`${classes.tooltipOverlay} ${getTooltipOverlayClass(darkMode)}`}
            >
                <Typography.Link
                    disabled={isSubscriptionExpired}
                    underline
                    onClick={handleOpen}
                    className={`${classes.link} ${getThemeColorClass(darkMode)}`}
                >
                    Edit profile
                </Typography.Link>
            </Tooltip>
            <EditProfileModal editableUser={editableUser} isOpen={isOpen} handleOpen={handleOpen} />
        </>
    );
};

export default EditProfileModalWrapper;
